module.exports = __webpack_public_path__ + "img/secret_two.b836ed11.png";